import { render, staticRenderFns } from "./formSimple.vue?vue&type=template&id=1a4a467f&scoped=true"
import script from "./formSimple.vue?vue&type=script&lang=js"
export * from "./formSimple.vue?vue&type=script&lang=js"
import style0 from "./formSimple.vue?vue&type=style&index=0&id=1a4a467f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a467f",
  null
  
)

export default component.exports